import React,{useContext} from "react";
import "../../cssfiles/homepage.css";
import { ThemeContext } from "../Homepage";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import LK_RadioButtonCheck from "../../images/LK_RadioButtonCheck";
import LK_RadioButtonUncheck from "../../images/LK_RadioButtonUncheck";
import { useEffect } from "react";

export default function CustomRadioButton({ onChange,id,width,optionWidth,formLabelText,row,options,fontSize,required,defaultValue, disabledOptions }) {
    const{ theme }= useContext(ThemeContext);
    const [value, setValue] = React.useState(defaultValue?defaultValue:"");

    useEffect(() => {
        setValue(defaultValue?defaultValue:"");
    }, [defaultValue]);

    function handleonChange(event) {
        setValue(event.target.value);
        onChange(event);
    }

    return (
        <FormControl sx={{width: width?`${width}px`:'auto'}}>
            <FormLabel id="demo-radio-buttons-group-label" required = {required?required:false} sx={{color:theme == 'light'?"#3c3c3c":"#c1c1c1",fontSize:fontSize?fontSize:"16px",'&.MuiFormLabel-root.Mui-focused':{color:theme == 'light'?"#3c3c3c":"#c1c1c1"},fontFamily:'Roboto','.MuiFormLabel-asterisk':{color:'#dc272d'}}}>{formLabelText?formLabelText:null}</FormLabel>
            <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue={defaultValue?defaultValue:""}
                value={value}
                name="radio-buttons-group"
                row={row?row:false}
                onChange={handleonChange}
                // sx={{width: width?width:'auto'}}//'& .MuiSvgIcon-root': {fontSize: fontSize?`calc(${fontSize}px + 4px)`:"20px"}
            >
                {options.length!==0?
                    options.map((val,index)=>
                        <>
                            <FormControlLabel disabled = {disabledOptions ? disabledOptions.includes(val[1]) : false} sx={{'& .MuiFormControlLabel-label': { fontSize: fontSize?fontSize:"16px" }, width : optionWidth?`${optionWidth}px`:'auto',color:theme == 'light'?"#3c3c3c":"#c1c1c1"}} value={val[1]} control={<Radio checkedIcon={<LK_RadioButtonCheck color={'#005c8e'} width={`${fontSize}px`} height={`${fontSize}px`} />} icon={<LK_RadioButtonUncheck color={'#005c8e'} width={`${fontSize}px`} height={`${fontSize}px`}/>} sx={{color: theme == 'light'?"#3c3c3c":"#c1c1c1",'&.Mui-checked': {color: '#005c8e'},fontFamily:'Roboto'}}/>} label={val[0]} />
                        </>
                    )
                    
                :
                <></>
            }

            </RadioGroup>
        </FormControl>
    )
}

{/* {options.length!==0?
                    {options.map(({[]},index)=>{
                        <>
                            <FormControlLabel value="val" control={<Radio/>} label="val" />
                        <FormControlLabel value="val" control={<Radio/>} label="val" />
                        <FormControlLabel value="val" control={<Radio/>} label="val" />
                        <FormControlLabel value="val" control={<Radio/>} label="val" />
                        </>
                        })
                    }
                :
                <></>
            } */}
            {/* {options.length!==0? *  }
            {options.map((val,index)=>{
                // <FormControlLabel value={val} control={<Radio/>} label={val} />
                <h1>hi</h1>
            })}
            {/* :
            <></>
        } */}